var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  placeholder: "Digite un código...",
                  id: "codigo",
                  name: "codigo",
                  readonly: _vm.form.estado !== "N"
                },
                model: {
                  value: _vm.form.codigo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo", $$v)
                  },
                  expression: "form.codigo"
                }
              },
              [
                _vm._v("\n            Código*\n            "),
                _vm.errores.codigo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.codigo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "descripcion",
                  placeholder: "Escriba una descripción..."
                },
                model: {
                  value: _vm.form.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "descripcion", $$v)
                  },
                  expression: "form.descripcion"
                }
              },
              [
                _vm._v("\n            Descripción*\n            "),
                _vm.errores.descripcion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.descripcion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipo,
                  expression: "form.tipo"
                }
              ],
              attrs: {
                type: "radio",
                value: "D",
                disabled: _vm.form.estado !== "N"
              },
              domProps: { checked: _vm._q(_vm.form.tipo, "D") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.form, "tipo", "D")
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Nota de Débito")])
          ]),
          _vm._v(" "),
          _c("label", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.tipo,
                  expression: "form.tipo"
                }
              ],
              attrs: {
                type: "radio",
                value: "C",
                disabled: _vm.form.estado !== "N"
              },
              domProps: { checked: _vm._q(_vm.form.tipo, "C") },
              on: {
                change: function($event) {
                  return _vm.$set(_vm.form, "tipo", "C")
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("Nota de Crédito")])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Motivo")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-008e1cae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-008e1cae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Motivo.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-008e1cae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/general/Motivo.vue
// module chunks = 0